import { Button } from 'primereact/button'
import React, { ReactNode, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import useText from '../../hooks/useText'

type PaywalledProps = {
    children: ReactNode
    bodyRowOne: string
    bodyRowTwo: string
}

export const Paywalled: React.FC<PaywalledProps> = ({ children, bodyRowOne, bodyRowTwo }) => {
    const navigate = useNavigate()
    const text = useText()
    const [isOverlayHovered, setIsOverlayHovered] = useState(false)

    return (
        <div className="relative">
            <div
                className={'pointer-events-none select-none'}
                style={{ inset: 0, opacity: isOverlayHovered ? 0.3 : 1, transition: 'opacity 150ms ease-in-out' }}
            >
                {children}
            </div>

            <div
                className="absolute flex flex-column align-items-center justify-content-center gap-3 z-3"
                onMouseEnter={() => setIsOverlayHovered(true)}
                onMouseLeave={() => setIsOverlayHovered(false)}
                style={{ inset: 0, opacity: isOverlayHovered ? 1 : 0.4, transition: 'opacity 150ms ease-in-out' }}
            >
                <div className="flex align-items-center">
                    <i
                        className="fa fa-lock text-8xl text-gray-800"
                        style={{ textShadow: '0 6px 18px rgba(0, 0, 0, 0.4)' }}
                    ></i>
                </div>

                <div
                    className="flex flex-column align-items-center text-lg text-center w-8"
                    style={{ textShadow: '0 2px 8px rgba(0, 0, 0, 0.35)' }}
                >
                    <div className="mb-4">
                        <p className="m-0">{bodyRowOne}</p>
                        <p className="m-0">{bodyRowTwo}</p>
                    </div>

                    <Button
                        type="button"
                        onClick={() => navigate('/billing')}
                        label={text('lblUpgradePlan')}
                        icon="pi pi-arrow-up-right"
                        iconPos="right"
                        className="align-self-center"
                        style={{ boxShadow: '0 6px 16px rgba(0, 0, 0, 0.35)' }}
                    />
                </div>
            </div>
        </div>
    )
}
